import React from "react";
import Render from "../../utilities/Render";

class SubscribeBanner extends React.Component {
  constructor(props) {
    super();
    this.state = {
      isClicked: false,
      privacyCheckBoxState: false
    };
  }

  componentDidMount() {
    // Campaign Monitor form script
    const script = document.createElement("script");
    script.src =
      "https://js.createsend1.com/javascript/copypastesubscribeformlogic.js";
    script.async = true;
    document.body.appendChild(script);

    //set listeners
    document.addEventListener("click", this.checkClick);
    window.addEventListener("scroll", window.scroll);

    this.checkCookie();
  }

  //check against clicked state then disable the scroll
  checkClick = () => {
    if (this.state.isClicked) {
      this.disableScroll();
    }
  };

  //cookies
  checkCookie = () => {
    if (document.cookie.indexOf("bvsubscribe=1") > -1) {
      this.disableScroll();
    } else {
      const footerHeight = document.getElementById("footer").offsetHeight;
      const subscribeHeight = document.getElementById("subscribe").offsetHeight;
      const bodyHeight = document.body.offsetHeight - footerHeight;

      window.onscroll = () => {
        if (window.innerHeight + pageYOffset >= bodyHeight - subscribeHeight) {
          this.disableScroll();
        } else {
          this.enableScroll();
          this.checkClick();
        }
      };
    }
  };

  /* temp clear cookie function dev testing
	clearCookie = () =>{	
		var d = new Date;
		document.cookie = "bvsubscribe=1 ; expires ="  + d.toGMTString() + "path=/;"
		this.setState({isClicked: 'false'})
	}*/

  enableScroll = () => {
    this.setState({ status: "scroll" });
  };

  disableScroll = () => {
    this.setState({ status: "relative" });
  };

  //set value of on click to true
  stopScroll = () => {
    this.setState({ isClicked: "true" });
    var d = new Date();
    document.cookie =
      "bvsubscribe=1; expires=" + d.getTime() + 31556952 + "path=/;";
  };

  checkBoxEventHandler = e => {
    if (e.keyCode === 13 || e.type == "click" || e.keyCode == 32) {
      if (this.state.privacyCheckBoxState == false) {
        this.setState({ privacyCheckBoxState: true });
      } else {
        this.setState({ privacyCheckBoxState: false });
      }
    }

    this.transferFocus(e);
  };

  transferFocus = e => {
    let currentElement = e.target.getAttribute("id");
    if (
      e.keyCode === 9 &&
      e.shiftKey == false &&
      currentElement == "fieldEmail"
    ) {
      setTimeout(function() {
        document
          .querySelectorAll(".privacy-checkbox-container span")[0]
          .focus();
      }, 20);
    }
    if (e.keyCode === 9 && currentElement == "checkbox-wrapper") {
      setTimeout(function() {
        document.querySelectorAll(".js-cm-submit-button")[0].focus();
      }, 20);
    }
    if (
      e.keyCode === 9 &&
      e.shiftKey == false &&
      currentElement == "subscribe-submit-button"
    ) {
      setTimeout(function() {
        console.log(currentElement);
        document.querySelectorAll(".privacy-checkbox-container a")[0].focus();
      }, 20);
    }
  };

  render() {
    return (
      <div>
        <div id="subscribe" className={this.state.status}>
          <div className="btn-wrap">
            <button
              type="button"
              className="fa fa-times close-btn"
              aria-label="Close"
              onClick={this.stopScroll}
            ></button>
          </div>
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-5">
                <h2>{this.props.data.heading}</h2>
                <p>{this.props.data.description}</p>
              </div>

              <div className="col-md-7 form-container">
                <form
                  id="SBV Update subscription"
                  className="js-cm-form"
                  action="https://www.createsend.com/t/subscribeerror?description="
                  method="post"
                  data-id="5B5E7037DA78A748374AD499497E309EC465DA410D68EE24B8BD95AD56FEF252E8D44DE937EF916A145DEBB64971F08EB320A0F825FAAAE30ADE05268A11AA5C"
                >
                  <fieldset>
                    <div className="row">
                      <div className="form-group col-md-9 pr-md-2">
                        <label
                          htmlFor="fieldName"
                          className="sr-only form-control"
                        >
                          Name
                        </label>
                        <input
                          id="fieldName"
                          className="form-control"
                          name="cm-name"
                          type="text"
                          placeholder="Name"
                        />
                      </div>

                      <div className="form-group col-md-3">
                        <label
                          htmlFor="fielddjyhjhth"
                          className="sr-only form-control"
                        >
                          Postcode
                        </label>
                        <input
                          id="fielddjyhjhth"
                          className="form-control"
                          name="cm-f-djyhjhth"
                          type="text"
                          placeholder="Postcode"
                        />
                      </div>
                    </div>

                    <div className="row mb-md-2" id="subscribe__emailsubmit">
                      <div className="col form-group d-flex flex-column flex-lg-row">
                        <input
                          id="fieldEmail"
                          name="cm-oplko-oplko"
                          type="email"
                          className="js-cm-email-input form-control mb-lg-0 flex-grow"
                          required
                          placeholder="Your email address (required)"
                          onKeyDown={e => this.transferFocus(e)}
                        />
                        <button
                          className="js-cm-submit-button subscribe-btn-submit-margin-left"
                          id="subscribe-submit-button"
                          type="submit"
                          onKeyDown={e => this.transferFocus(e)}
                        >
                          Subscribe
                        </button>
                      </div>
                    </div>

                    <div className="row">
                      <div className="form-group privacy-checkbox-container">
                        <label className="terms" htmlFor="cm-privacy-consent">
                          <span
                            onKeyDown={e => this.checkBoxEventHandler(e)}
                            onClick={e => this.checkBoxEventHandler(e)}
                            tabIndex="0"
                            id="checkbox-wrapper"
                          >
                            <input
                              required
                              type="checkbox"
                              name="cm-privacy-consent"
                              id="cm-privacy-consent"
                              className="checkbox"
                              checked={this.state.privacyCheckBoxState}
                              //defaultChecked={this.state.privacyCheckBoxState}
                            />
                          </span>
                          <span class="privacy-text">
                            I have read the{" "}
                            <a
                              title="Link opens in a new window"
                              target="_blank"
                              href="https://business.vic.gov.au/privacy/"
                            >
                              privacy statement
                            </a>{" "}
                            <span className="form-required">(required)</span>
                          </span>
                        </label>

                        <input
                          id="cm-privacy-consent-hidden"
                          name="cm-privacy-consent-hidden"
                          type="hidden"
                          value="true"
                        />
                      </div>
                    </div>
                  </fieldset>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Render.Component("#subscribe-banner-react", subscribeDataCMS, SubscribeBanner);

export default SubscribeBanner;
